var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.7,
    height: 41.7,
    viewBox: "0 0 41.7 41.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 41.7,
    height: 41.7,
    rx: 10,
    ry: 10,
    fill: "#a8cfdf",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.85,37.29c-9.07,0-16.44-7.38-16.44-16.44S11.79,4.41,20.85,4.41s16.44,7.38,16.44,16.44-7.38,16.44-16.44,16.44Zm0-32.46c-8.84,0-16.02,7.19-16.02,16.02s7.19,16.02,16.02,16.02,16.02-7.19,16.02-16.02S29.69,4.83,20.85,4.83Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.85,32.58c-6.47,0-11.73-5.26-11.73-11.73,0-6.04,4.53-11.06,10.53-11.67h.22c.58-.07,1.03-.06,1.24-.06h.07c.34,0,.69.04.7.05,5.99.52,10.69,5.65,10.69,11.68,0,6.47-5.26,11.73-11.73,11.73Zm-2.1-22.84c-5.31.98-9.21,5.61-9.21,11.12,0,6.24,5.07,11.31,11.31,11.31s11.31-5.07,11.31-11.31c0-5.49-4.04-10.2-9.35-11.14,2.18.95,3.99,2.63,4.09,2.72,3.21,3.34,3.85,8.66,1.48,12.39-1.14,1.81-2.89,3.18-4.91,3.86-3.04,1.03-6.53.3-8.69-1.83-2.3-2.27-2.84-5.98-1.26-8.62,1.66-2.78,5.49-3.86,8.2-2.31,1.71.98,2.76,2.93,2.54,4.72-.24,1.97-2.08,3.56-3.94,3.41-.96-.08-1.9-.69-2.45-1.59-.51-.84-.62-1.79-.28-2.6l.38.16c-.29.68-.19,1.49.25,2.22.48.79,1.3,1.33,2.13,1.39,1.65.13,3.28-1.29,3.49-3.05.2-1.64-.76-3.41-2.33-4.31-2.47-1.42-6.11-.39-7.63,2.16-1.46,2.44-.94,6.01,1.2,8.11,2.04,2.02,5.36,2.72,8.26,1.73,1.93-.66,3.6-1.97,4.69-3.69,2.23-3.51,1.6-8.73-1.42-11.87-.02-.02-2.97-2.75-5.76-3.19l-.93.05c-.13.01-.27.03-.42.05-.06,0-.12.01-.19.02-.15.02-.34.04-.54.08h0Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.3a8ec8cbf3f26fb1cbb7163059fe4592.svg";
export { ForwardRef as ReactComponent };